import React, { useContext, useState, Component } from "react";
import { Redirect } from "react-router";
import styled from "styled-components";

import PlaylistService from "../../../service/playlist-service";
import ToastService from "../../../service/toast-service";
import YoutubeResult from "./youtube";
import OptionsOnAll from "./options-on-all";

import MaterialButton from "@material-ui/core/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { Theme } from "../../../theme/theme-provider";
import { Box, Text, Col, Row, SearchBox, VGap } from "../../../comps";

const Wrapper = styled(Col)`
  width: 100%;
  height: 100%;
  align-items: center;
  padding-left: 30px;
  padding-right: 30px;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.color.GRAY_2};
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.color.GRAY_1};
    border-radius: 20px;
  }
  &::-webkit-scrollbar-thumb:hover {
  }
`;

const SearchWrapper = styled(Row)`
  width: 80%;
  height: 50px;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.6);
  border-radius: 5px;
  overflow: hidden;
  background: ${({ theme }) => theme.color.GRAY_3};
`;

const SearchBoxWrapper = styled(Box)`
  /* overflow: hidden; */
  width: 90%;
  height: 50px;
`;

const ResultWrapper = styled(Col)`
  flex-grow: 1;
  width: 100%;
`;

export default () => {
  const [data, setData] = useState(null);
  const handleUrlSubmit = async (url) => {
    const payload = await PlaylistService.importUrl({ url });
    if (payload && payload.length === 2) {
      const [type, data] = payload;
      if (type >= 2) setData(data);
      else console.log(data)
    }
  };

  const resultComp = () => {
    if (data)
      return [
        <VGap height="30px" />,
        <OptionsOnAll songs={data} />,
        <VGap height="30px" />,
        <ResultWrapper>{data && <YoutubeResult songs={data} />}</ResultWrapper>,
        <VGap height="90px" />,
      ];
  };

  return (
    <Wrapper>
      <VGap height="30px" />
      <SearchBoxWrapper>
        <SearchBox
          placeholder="Add a valid youtube or spotify playlist or song url"
          textColor="#d7e0da"
          background={Theme.color.GRAY_3}
          textAlign="center"
          fontSize="18px"
          buttonTextColor="#fff"
          buttonBackground={Theme.color.BLUE_5}
          buttonName="Import"
          buttonIcon={faPlus}
          buttonFontSize="16px"
          buttonRatio={30}
          onClick={handleUrlSubmit}
        />
      </SearchBoxWrapper>
      {resultComp()}
    </Wrapper>
  );
};
